export const handleDocUpload = (
  length: number,
  orderId: string,
  setFormData: (updater: (prevFormData: any) => any) => void,
  generatedPath: string,
) => {
  if (length > 0) {
    setFormData((prevFormData) => ({
      ...prevFormData,
      filePath: generatedPath,
    }));
  } else {
    setFormData((prevFormData) => ({
      ...prevFormData,
      filePath: "",
    }));
  }
};
